import { Component, OnInit } from '@angular/core';
import { AuthUser } from '@app/account/account-api';
import {
  FlexEdService,
  FlexEdTransaction,
} from '@app/flex-ed/services/flex-ed.service';
import { AuthService } from '@app/shared/services/auth.service';
import {
  FlexEdDetails,
  FlexedService,
} from '@app/shared/services/flexed.service';
import { NotifierService } from '@app/shared/services/notifier.service';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'dgx-flex-ed-view',
  templateUrl: './flex-ed-view.component.html',
})
export class FlexEdViewComponent implements OnInit {
  public isLoading: boolean;
  public cardDetails: FlexEdDetails;
  public transactionHistory: FlexEdTransaction[];
  private authUser: AuthUser = this.authService.authUser;
  constructor(
    private authService: AuthService,
    private flexEdService: FlexEdService,
    private notifierService: NotifierService,
    private sharedFlexEdService: FlexedService,
    private translate: TranslateService
  ) {}

  public ngOnInit(): void {
    this.isLoading = true;
    forkJoin([this.getCardDetails(), this.getTransactions()]).subscribe(
      ([cardDetails, transactionHistory]) => {
        this.cardDetails = cardDetails;
        this.transactionHistory = transactionHistory;
        this.isLoading = false;
      },
      () => {
        this.notifierService.showError(
          this.translate.instant('FlexEdCtrl_ErrorRetrieving')
        );
        this.isLoading = false;
      }
    );
  }

  public showUpdateFlexCardModal() {
    this.flexEdService
      .showUpdateFlexCardModal({
        orgId: this.authUser.defaultOrgId,
        cardDetails: this.cardDetails,
      })
      .pipe(
        tap(() => {
          this.isLoading = true;
        }),
        switchMap(() => {
          return this.getCardDetails();
        })
      )
      .subscribe(() => (this.isLoading = false));
  }

  private getCardDetails() {
    return this.sharedFlexEdService.getCardDetails(
      this.authUser?.viewerProfile?.userProfileKey,
      true
    );
  }

  private getTransactions() {
    return this.flexEdService.getTransactionHistory(
      this.authUser?.viewerProfile.userProfileKey
    );
  }
}
